<template lang="pug">
  .profile-page__main
    .profile-page__body
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Педагоги
        .profile-section__body
          .form
            .form__elem.form__elem_full
              manager-shift-editor-copy-form-data(
              v-if="otherShifts.length > 0"
              :options="otherShifts"
              :current-data="fields"
              :current-shift="shiftData"
              @update-field="updateField"
              @cancel-update-field="cancelUpdateField"
              )
            .form__group(
              v-for="(item, index) in fields.teachers"
            )
              .form__elem
                .form-elem
                  .form-elem__body
                    .upload-photo
                      .upload-photo__img
                        .upload-photo-img(
                        v-bind:style="getLocalAvatarUrl(item.avatar)"
                        )
                      .upload-photo__body
                        .drop-area
                          .drop-area__title.drop-area-title
                            .drop-area-title__icon
                              img(src="@/assets/images/icons/clip.svg")
                            .drop-area-title__text Добавить фото
                          .drop-area__description Максимум 3 мб. JPG
                          .input-file
                            label.input-file__label
                              input.input-file__input(
                              type="file"
                              @change="onAddAvatar($event, index)"
                              )
                              .input-file__outline
              .form__elem
                .form-elem.form-elem_horizontal
                  .form-elem__title ФИО
                  .form-elem__body
                    input.input.input_full(
                    maxlength="50"
                    v-model="item.fio"
                    )
              .form__elem
                .form-elem.form-elem_horizontal
                  .form-elem__title Должность
                  .form-elem__body
                    input.input.input_full(
                    maxlength="50"
                    v-model="item.post"
                    )
              .form__elem
                .form-elem.form-elem_horizontal
                  .form-elem__title Информация
                  .form-elem__body
                    input.input.input_full(
                    maxlength="50"
                    v-model="item.extra"
                    )
            .form__elem
              .form-elem.form-elem_right
                .form-elem__title
                .form-elem__body
                  button.button.button_paint-main--light.button_narrow(
                  @click.prevent="onAddItem"
                  )
                    .button__text Добавить
      section.profile-page-form__section.profile-section
        .profile-section__body
          .form
            .form__elem.form__elem_button
              .form-elem
                .form-elem__body
                  button.button.button_paint-main.button_long(
                  @click.prevent="onSaveCamp()"
                  )
                    .button__text Сохранить
                .form-elem__error(
                v-if="currentErrorMessage.length > 0"
                ) {{currentErrorMessage}}

</template>

<script>

import {mapActions} from "vuex";
import ManagerShiftEditorCopyFormData from "./components/ManagerShiftEditorCopyFormData";

export default {
  name: "ManagerShiftEditorTeachers",
  components: {ManagerShiftEditorCopyFormData},
  props: {
    currentErrorMessage: {
      type: String,
      default: ""
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    shiftData: {
      type: Object,
      default: () => ({})
    },
    otherShifts: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      fields: {
        teachers: [
          {
            avatar: {
              file: null
            },
            fio: "",
            post: "",
            extra: ""
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions(["addAttachments"]),
    Teacher() {
      this.avatar = {
        file: null
      };
      this.fio = "";
      this.post = "";
      this.extra = "";
    },
    onAddItem() {
      this.fields.teachers.push(new this.Teacher());
    },
    getLocalAvatarUrl(url) {
      if (url.file) {
        return url ? "background-image: url(" + url.file + ")" : "";
      }
    },
    onAddAvatar(e, i) {
      const file = e.target.files[0];
      const formData = new FormData();
      const type = "1"; // image
      if (!file || !type) {
        return;
      }
      formData.append("file", file);
      formData.append("attachment_type", type);
      this.addAttachments(formData).then(response => {
        this.fields.teachers[i].avatar = response.data;
      });
      e.target.value = "";
    },
    setFields(data) {
      if (data.teachers.length > 0) {
        this.fields.teachers = data.teachers.map(item => {
          return {
            avatar: item.photo,
            fio: item.fio,
            post: item.present_post,
            extra: item.extra
          };
        });
      }
    },
    onSaveCamp() {
      const completedFields = this.fields.teachers.filter(item => {
        if (item.extra.length > 0 || item.fio.length > 0 || item.post.length > 0) {
          return item;
        }
      });
      if (completedFields.length > 0) {
        this.fields.teachers = completedFields;
      }
      const teachers = completedFields.map(item => {
        return {
          fio: item.fio,
          extra: item.extra,
          present_post: item.post,
          photo: item.avatar.id
        };
      });
      const data = {
        teachers: teachers
      };
      this.$emit("on-save-shift", data);
    },

    updateField(data) {
      this.setFields(data);
    },
    cancelUpdateField(data) {
      for (const key in data) {
        this.fields[key] = data[key];
      }
    }
  },
  watch: {
    shiftData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    if (this.shiftData) {
      this.setFields(this.shiftData);
    }
  }
};
</script>
